const Ajv = require("ajv");
const addFormats = require("ajv-formats");

const ajv = new Ajv({
    strict: false,
    allErrors: true,
    strictRequired: true,
    allowDate: true,
    loopEnum: 60,
    loopRequired: 60,
    ownProperties: true,
    verbose: true // dony set
});
addFormats(ajv);

const schemaStandard = {
    type: "array",
    minItems: 1,
    items: {
        type: "object",
        properties: {
            name: {
                type: "string",
                minLength: 3
            },
            type: {
                type: "string",
                minLength: 3,
                enum: [
                    "input",
                    "date",
                    "choice",
                    "boolean",
                    "photo",
                    "geo",
                    "label",
                    "video",
                    "viewer",
                    "map",
                    "datasource",
                    "subform",
                    "file",
                    "signature"
                ]
            },
            label: {
                type: "string",
                minLength: 3
            },
            required: {
                type: "boolean"
            },
            help: {
                type: "string",
                minLength: 3
            },
            inputType: {
                type: "string",
                minLength: 3,
                enum: [
                    "default",
                    "email",
                    "barcode",
                    "phone",
                    "textarea",
                    "password",
                    "ranking",
                    "slider",
                    "number",
                    "currency",
                    "ipv4",
                    "ipv6",
                    "domain",
                    "multiInput",
                    "checktext",
                    "QRReader",
                    "QRGen",
                    "datetime",
                    "calendar",
                    "time",
                    "sign",
                    "photo",
                    "dialog",
                    "multi",
                    "multiOther",
                    "radio",
                    "radioOther",
                    "standar",
                    "switch",
                    "gallery/camera",
                    "gallery",
                    "camera",
                    "servi",
                    "google",
                    "location",
                    "label",
                    "link",
                    "paragraph",
                    "section",
                    "url",
                    "web",
                    "document",
                    "database",
                    "select",
                    "subformulario",
                    "info",
                    "action",
                    "unixtime",
                    "scala",
                    "flex"
                ]
            },
            maxLength: {
                type: "number",
                minimum: 1
            },
            properties: {
                type: "object",
                properties: {
                    min: { type: "number" },
                    max: { type: "number" },
                    default: {
                        type: ["string", "integer", "boolean"]
                    },
                    // default: [{ type: "string" }, { type: "integer" }, { type: "boolean" }],
                    size: { type: "number" },
                    color: { type: "string" },
                    orientation: { type: "string" },
                    minValue: { type: "number" },
                    maxValue: { type: "number" },
                    limit: { type: "number" },
                    originKey: { type: "string" },
                    searchField: { type: "string" }
                },
                additionalProperties: false
            },
            options: {
                type: "array",
                minItems: 1,
                items: {
                    type: "string",
                    minLength: 1
                }
            },
            content: {
                type: "string",
                minLength: 3,
                description: JSON.stringify({
                    type: "string",
                    msg: "msgErrorContent"
                }),
            },
            key: {
                type: "string",
                minLength: 3
            },
            related: {
                type: "object",
                // properties: {
                //   answer: {
                //     type: ["string", "integer", "boolean"],
                //     minLength: 2,
                //     minimum: 0
                //   },
                //   answers: {
                //     type: "array",
                //     minItems: 1,
                //     items: {
                //       type: ["string", "integer", "boolean", "object"]
                //     }
                //     // items: [{type: "integer"}, {type: "string"}, {type: "boolean"}, , {type: "object"}]
                //   },
                //   name: {
                //     type: "string",
                //     minLength: 3
                //   },
                //   question: {
                //     type: "number",
                //     minimum: 0
                //   },
                //   relatedness: {
                //     type: "string",
                //     minLength: 2,
                //     enum: ["simple", "compound", "multiple", "listener"]
                //   },
                //   type: {
                //     type: "string",
                //     minLength: 3
                //   }
                // },

                anyOf: [
                    {
                        required: ["answers", "type", "relatedness"],
                        additionalProperties: false,
                        properties: {
                            answers: {
                                type: "array",
                                minItems: 1,
                                items: {
                                    type: ["string", "integer", "boolean", "object"]
                                }
                            },
                            type: {
                                type: "string",
                                minLength: 3
                            },
                            relatedness: {
                                type: "string",
                                minLength: 2,
                                enum: ["compound"]
                            }
                        }
                    },
                    {
                        required: ["name", "question", "relatedness"],
                        additionalProperties: false,
                        properties: {
                            answers: {
                                type: "array",
                                minItems: 1,
                                items: {
                                    type: ["string", "integer", "boolean", "object"]
                                }
                            },
                            answer: {
                                type: ["string", "integer", "boolean"],
                                minLength: 1,
                                minimum: 0
                            },
                            name: {
                                type: "string",
                                minLength: 3
                            },
                            question: {
                                type: "number",
                                minimum: 0,
                                description: JSON.stringify({
                                    type: "string",
                                    msg: "msgErrorIndex"
                                }),
                            },
                            relatedness: {
                                type: "string",
                                minLength: 2,
                                enum: ["simple", "multiple", "listener"]
                            }
                        }
                    }
                ]

                // anyOf: [
                //   {
                //     if: { properties: { relatedness: { enum: ["compound"] } }},
                //     then: { required: ["relatedness"]},
                //   },
                //   {
                //     if: { properties: { relatedness: { enum: ["simple", "multiple", "listener"] } }},
                //     then: { required: ["name", "question"]},
                //   }
                // ],

                // required: ["name", "question", "relatedness"],
                // if: { properties: { relatedness: { enum: ["compound"] } }},
                // then: { required: ["relatedness"]},
                // else: { required: ["name", "question", "relatedness"]},
                // allOf: [
                //   {
                //     if: {
                //       properties: { relatedness: { enum: ["compound"] } }
                //     },
                //     then: { required: ["relatedness"] },
                //   },
                //   {
                //     if: {
                //       properties: { relatedness: { enum: ["simple", "multiple", "listener"] } }
                //     },
                //     then: { required: ["name", "question", "relatedness"] },
                //   }
                // ],

                // additionalProperties: false
            },
            inherited: {
                type: "array",
                minItems: 1,
                description: JSON.stringify({
                    type: "string",
                    msg: "msgErrorInheritedSubform"
                })
            },
            data: {
                type: "array",
                minItems: 1,
                description: JSON.stringify({
                    type: "string",
                    msg: "msgErrorData"
                })
            },
            query: {
                type: "object",
                additionalProperties: false,
                properties: {
                    type: { type: "string" },
                    q: { type: "string" },
                    message: { type: "string" },
                    action: { type: "string" }
                }
            },
            actions: {
                type: "object",
                required: ["id", "mode", "type", "questions"],
                properties: {
                    id: { type: "string", maxLength: 32 },
                    mode: { type: "string", enum: ["on_trigger", "on_depend", "on_event"] },
                    type: { type: "string" },
                    operation: {
                        type: "string",
                        enum: ["add", "sub", "divider", "multiply", "concat", "avg", "mode", "median", "min", "max"],
                        description: JSON.stringify({
                            type: "string",
                            msg: "msgContainerElements"
                        })
                    },
                    questions: {
                        type: "array",
                        minItems: 1,
                        description: JSON.stringify({
                            type: "array",
                            msg: "smgTwoElements"
                        })
                    }
                },
                additionalProperties: false,
                required: ["id", "mode", "type", "operation", "questions"],
                allOf: [
                    {
                        if: { properties: { operation: { enum: ["mode"] } } },
                        then: {
                            properties: {
                                questions: {
                                    minItems: 3,
                                    description: JSON.stringify({
                                        type: "array",
                                        msg: "smgModeSchema"
                                    })
                                }
                            }
                        }
                    }
                ]
            }
        },
        additionalProperties: false,
        required: ["name", "type", "label", "required", "inputType"]
    }
};

export const validationStandard = json => {
    const validate = ajv.compile(schemaStandard);
    const valid = validate(json);
    // if (!valid) console.log(validate.errors)
    return { valid, error: validate.errors };
};
